import { render, staticRenderFns } from "./build-tabs.vue?vue&type=template&id=59211dd6&scoped=true&"
import script from "./build-tabs.vue?vue&type=script&lang=js&"
export * from "./build-tabs.vue?vue&type=script&lang=js&"
import style0 from "./build-tabs.vue?vue&type=style&index=0&id=59211dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59211dd6",
  null
  
)

export default component.exports